// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// import { getAuth, onAuthStateChanged } from "firebase/auth";
// import { getFirestore } from "firebase/firestore";
import {
  getFirestore,
  doc,
  updateDoc,
  getDoc,
  increment,
} from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAkN8-Qk88lbFP_cZiSyams6oqflNimsHM",
  authDomain: "crypto-investment-worldwide.firebaseapp.com",
  projectId: "crypto-investment-worldwide",
  storageBucket: "crypto-investment-worldwide.firebasestorage.app",
  messagingSenderId: "389352235654",
  appId: "1:389352235654:web:a723b5545f44a55242e707",
  measurementId: "G-2BCBZKLZM4",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, analytics, auth, db, doc, updateDoc, getDoc, increment };
